import Swal, { SweetAlertOptions } from 'sweetalert2';

/**
 * Classes do modelo de alerta do IMAP. Ficam aqui para que a instância padrão
 * e o AlertaService compartilhem exatamente a mesma aparência.
 */
export const CLASSES_ALERTA: SweetAlertOptions['customClass'] = {
  container: 'swal-imap-fundo',
  popup: 'swal-imap-popup',
  icon: 'swal-imap-icone',
  title: 'swal-imap-titulo',
  htmlContainer: 'swal-imap-texto',
  closeButton: 'swal-imap-fechar',
  actions: 'swal-imap-acoes',
  confirmButton: 'swal-imap-botao swal-imap-botao-primario',
  denyButton: 'swal-imap-botao swal-imap-botao-perigo',
  cancelButton: 'swal-imap-botao swal-imap-botao-neutro',
  loader: 'swal-imap-loader',
  input: 'swal-imap-campo',
  inputLabel: 'swal-imap-campo-rotulo',
  validationMessage: 'swal-imap-validacao',
  timerProgressBar: 'swal-imap-progresso',
};

const ENTIDADES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

/** Escapa conteudo vindo da API antes de interpolar no html de um alerta. */
export function escaparHtml(valor: string): string {
  return valor.replace(/[&<>"']/g, (caractere) => ENTIDADES[caractere]);
}

export const BASE_ALERTA: SweetAlertOptions = {
  buttonsStyling: false,
  reverseButtons: true,
  customClass: CLASSES_ALERTA,
};

/**
 * SweetAlert2 já com o modelo do sistema aplicado. Importe daqui em vez de
 * 'sweetalert2' para que o alerta acompanhe o tema e o modo claro/escuro.
 */
const SwalImap = Swal.mixin(BASE_ALERTA);

export default SwalImap;
